export { default } from './useScrollTrigger';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/useScrollTrigger/index.js
// module id = 872
// module chunks = 2